export enum RadioPanelDropShadowType {
    None = 'noShadow',
    Small = 'smallShadow',
    Medium = 'mediumShadow',
}
